import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";

type Props = {
  Percentage: number;
};

const Percentage = ({ Percentage }: Props) => {
  return (
    <div className="flex items-center">
      {Percentage > 0 ? (
        <>
          <IoMdArrowDropup className="text-[#05CD99] text-base font-bold" />
          <span className="text-[#05CD99] text-xs font-bold">
            +{Percentage}%
          </span>
        </>
      ) : (
        <>
          <IoMdArrowDropdown className="text-[red] text-base font-bold" />

          <span className="text-[red] text-xs font-bold">{Percentage}%</span>
        </>
      )}
    </div>
  );
};

export default Percentage;
